import api from '@/api/axiosConfig.js';

export const fetchRepartos = params => api.get('/api/repartos', { params });

export const fetchReparto = id => api.get(`/api/repartos/${id}`);

/**
 * Opens the authenticated planilla de distribucion PDF in a new tab.
 * The tab is opened synchronously (inside the click) so browsers do not block it.
 */
export async function openRepartoPlanilla(id) {
  const popup = window.open('', '_blank');
  try {
    const response = await api.get(`/api/repartos/${encodeURIComponent(id)}/planilla`, {
      responseType: 'blob',
      headers: { Accept: 'application/pdf' },
    });
    const objectUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    if (popup) {
      popup.location.href = objectUrl;
    } else {
      window.open(objectUrl, '_blank');
    }
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  } catch (error) {
    popup?.close();
    throw new Error(error?.response?.status === 404
      ? 'La planilla del reparto no esta disponible.'
      : 'No se pudo abrir la planilla del reparto.');
  }
}
